import React from 'react';
import Link from 'next/link';
import Text from '@common/text';
import TermsDto from '@domain/rs/terms/TermsRs';

import { FontStyle } from '@domain/constant/fontStyle';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

export type TermType = 'LIST' | 'LINK';

interface TermProps extends TermsDto {
  termType?: TermType | undefined;
  href?: string;
  isChecked: boolean;
  onClick: () => void;
  isOpen: boolean;
  onOpen: () => void;
}

const Term = ({ termType = 'LIST', href = '', title, contents, isChecked, onClick, isOpen, onOpen }: TermProps) => {
  const hrefLink = href || '';

  switch (termType) {
    case 'LIST':
      return (
        <>
          <div className={cx('labelWrap')}>
            <label className={cx('label')}>
              <input
                type="checkbox"
                className={cx('input', 'hidden')}
                checked={isChecked}
                readOnly={true}
                onClick={onClick}
              />
              <span className={cx('mark')} />
              {title}
            </label>
            <a className={cx('btnOpen', { open: isOpen })} role="button" onClick={onOpen} />
          </div>
          <div className={cx('termsTextArea', { open: isOpen })}>
            <div
              className={cx('termsText')}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: contents,
              }}
            />
          </div>
        </>
      );
    case 'LINK':
      return (
        <div className={cx('linkArea')}>
          <label className={cx('label')}>
            <input
              type="checkbox"
              className={cx('input', 'hidden')}
              checked={isChecked}
              readOnly={true}
              onClick={onClick}
            />
            <span className={cx('mark')} />
          </label>

          <Link href={hrefLink} target={'_blank'} className={cx('titleArea')}>
            <Text fontStyle={FontStyle.B3_B}>{title}</Text>
          </Link>
        </div>
      );
    default:
      return null;
  }
};

export default Term;
